import { ItemInfo } from "../models/item";

export interface ItemEditState {
	editDialogOpen: boolean;
	editItemId: string | null;
	editItemData: ItemInfo | null;
}

export const getInitialItemEditState = (): ItemEditState => ({
	editDialogOpen: false,
	editItemId: null,
	editItemData: null
});

export const getItemEditStateForOpen = (
	itemId: string,
	item: ItemInfo
): ItemEditState => ({
	editDialogOpen: true,
	editItemId: itemId,
	editItemData: item
});

export const getItemEditStateForClose = (): ItemEditState => ({
	editDialogOpen: false,
	editItemId: null,
	editItemData: null
});

export const updateItemsWithEditedItem = (
	items: Record<string, ItemInfo>,
	itemId: string,
	updatedItem: ItemInfo
) => ({
	...items,
	[itemId]: updatedItem
});

// Prevent soft-deleting an item while it still has inventory remaining.
export const getItemDeleteValidationError = (
	item: ItemInfo | null | undefined
) => {
	if (!item) {
		return "Item not found.";
	}

	if (item.isDeleted) {
		return null;
	}

	if ((item.availableQuantity || 0) > 0) {
		return "Cannot delete item with available quantity greater than zero.";
	}

	return null;
};
